import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncAccountManagerView({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/accountManagerView"));
  console.log("Loading", AsyncAccountManagerView.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncAccountManagerView;
